import { connect } from 'react-redux';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';
import Form from './Form';

function mapStateToProps(state) {
  return {
    language: uiStateSelectors.selectResumeLanguage(state)
  };
}

export default connect(mapStateToProps, null)(Form);
